<template>
    <a-modal
      :title="title"
      :visible="visible"
      :closable="false"
      :okText="$t('live-communications.send-link-modal-ok-text')"
      :cancelText="$t('live-communications.send-link-modal-cancel-text')"
      :confirm-loading="isLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >

        <h5 style="text-align: center;margin-bottom: 5px;">{{ $t('live-communications.call') }}</h5>
        <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 10px;">
            <!-- <a-avatar
                slot="avatar"
                :size="64"
                shape="square"
                :src="officialImageUrl"
            /> -->
            <div style="margin-left: 10px; display: flex; flex-direction: column; align-items: start; justify-content: space-around;">
                <h6 style="margin-bottom: 0px; !important">{{ officialName }}</h6>
                <p style="font-weight: 600;margin-top: 0px !important">{{ officialDesignation }}</p>
            </div>
        </div>
      
        
        <a-form
            id="take-appointment-logged-in-form"
            class="take-appointment-logged-in-form"
            style="min-height: 300px !important;">
        
            <a-form-item>
                <a-form-item
                    :label="$t('live-communications.meeting-link') + ' (*)'" 
                    :validate-status="validations.statusPersonCount"
                    :help="validations.helpPersonCount"
                >
                    <a-select
                        :disabled="isLoading"
                        :loading="isLoading"
                        class="form-input ml-5"
                        style="width: 100%"
                        :not-found-content="isLoading ? undefined : null"
                        :placeholder="$t('form-placeholder.meeting-link')"
                        @change="onChangeMeetingLinkSelection"
                        :value="link"
                    >
                        <a-spin v-if="isLoading" slot="notFoundContent" size="large" />
                        <a-select-option v-for="item in allMeetingLinks" :key="item.id" :value="item.link">
                        {{item.name}} ({{ item.link }})
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item
                    :validate-status="validations.statusLink"
                    :help="validations.helpLink"
                >
                    <label style="color:#000; ">{{$t('live-communications.alter-meeting-link')}}</label>
                    <a-input
                        class="form-input"
                        :placeholder="$t('live-communications.meeting-link')"
                        v-model="inputLink"
                    />
                </a-form-item>
            </a-form-item>

            <div class="mt-20">
                <a href="https://zoom.us/meeting/schedule" target="_blank">
                    <img src="/images/logos/zoom-logo.png" style="height: 20px;width: 20px" alt=""> 
                    <strong> {{$t('live-communications.create-zoom-link')}}</strong>
                </a>
            </div>
            <!-- <div class="mt-20">
               <a href="https://meet.google.com/" target="_blank">
                    <img src="/images/logos/google-meet-logo.png" style="height: 20px;width: 20px" alt=""> 
                    <strong> {{$t('live-communications.create-google-link')}}</strong>
                </a> 
            </div> -->
        </a-form>

        
        
    </a-modal>
</template>
<script>


import { mapActions, mapState } from 'pinia';
import { toastMixin } from '../../mixins/ToastMixin';
import { useAuthStore } from '../../stores/auth-store';
import { useVisitorAppointmentsStore } from '../../stores/visitor-appointments-store';
import { meetingsClient } from "../../api/config.js";



export default {
    props: {
        hour: {
            type: Number,
            required: false,
        },
        min: {
            type: Number,
            required: false,
        },
        date: {
            type: String,
            required: false
        }
    },
    components: {
        
    },
    mixins: [ toastMixin ],
    data() {
        return {
            title: this.$t('live-communications.call'),
            link: '',
            inputLink: "",
            allMeetingLinks: [],
            item: {},
            isLoading: false,
            visible: false,
            duration: '15',
            meetingLink: '',
            //--
            type: '',
            topic: '',
            personCount: '',
            selectedOfficial: {},
            selectedOfficialId: '',
            validations: {
                statusType: '',
                helpType: '',
                statusSelectedOfficial: '',
                helpSelectedOfficial: '',
                statusLink: '',
                helpLink: '',
                statusTopic: '',
                helpTopic: '',
            },
            isLoading: false,
            officials: [],
            allOfficials: []
        }
    },
    computed: {
        ...mapState(useAuthStore, [ 'profile'] ),
        // officialImageUrl() {
        //     if (this.selectedOfficial && this.selectedOfficial.imageUrl && this.selectedOfficial.imageUrl.length > 0)
        //         return this.selectedOfficial.imageUrl;
        //     return '/images/default-avatar.jpg';
        // },
        officialName() {
            if (this.selectedOfficial && this.selectedOfficial.name)
                // console.log(this.selectedOfficial);
                this.officialMeetingLinks();
                return this.selectedOfficial.name;
            return '';
        },
        officialDesignation() {
            if (this.selectedOfficial && this.selectedOfficial && this.selectedOfficial.designation && this.selectedOfficial.designation.name)
                return this.selectedOfficial.designation.name;
            return '';
        },
        
    },
    methods: {
        ...mapActions(useVisitorAppointmentsStore, [ 'applyForAppointment' ]),
        officialMeetingLinks(){
            if (this.selectedOfficial && this.selectedOfficial.targetOfficial) {

                let data = {
                    id: this.selectedOfficial.targetOfficial,
                    page: 1,
                    size: 20
                }

                meetingsClient.fetchAllOfMeetingLinks(data).then(res => {
                    // console.log(res.body.list);
                    if (!res.networkError && res.status == 200){
                        this.allMeetingLinks = res.body.list;
                        this.isLoading = false;
                    }else{
                        this.isLoading = false;
                        console.log(res.status);
                    }
                });
            }
        },
        onChangeMeetingLinkSelection(e){
            this.link = e;
            // this.selectedMeetingLink = e;
            console.log("========");
            console.log(e);
        },
        clearValidations() {
            Object.keys(this.validations).forEach(key => {
                this.validations[key] = '';
            });
        },
        validate() {
            this.clearValidations();
            // if (this.inputLink.trim().length == 0) {
            //     this.validations.statusLink = 'error';
            //     this.validations.helpLink = 'Please enter a link count';
            //     return false;
            // }

            return true;

        },
        handleOk() {
            // this.approveSelectedAppointment(this.hour, this.min, this.date, Number(this.duration));
            // this.visible = false;

            // if (!this.validate()) {
            //     return;
            // }
            // this.$emit('success', { guest: this.item, link: this.link });
            // this.visible = false;

            if (this.validate()){
                let submitLink = "";
                if (this.link.trim().length > 0 && this.inputLink.trim().length > 0){
                    submitLink = this.inputLink;
                }
                if (this.link.trim().length == 0 && this.inputLink.trim().length > 0){
                    submitLink = this.inputLink;
                }
                if (this.link.trim().length > 0 && this.inputLink.trim().length == 0){
                    submitLink = this.link;
                }

                if (!submitLink.startsWith('https://'))
                    submitLink = "https://" + submitLink;
                this.$emit('success', { guest: this.item, link: submitLink });
                this.visible = false;
            }

            
            
        },
        handleCancel() {
            this.visible = false;
        },
        showModal(official) {
            this.selectedOfficial = official;
            this.item = official;
            this.visible = true;
        }
    },

    
}
</script>